import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { API_CONFIG, CONFIG, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";

import { TRANS_APIs } from "apihandlers/transaction";
import { AUTH_APIs } from "apihandlers/auth";

const thumbnailImg = require("assets/images/pdf.png");

const BalanceConfirmation = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [confirmStatus, setconfirmStatus] = useState("iAccept");

  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [creditFiles, setCreditFiles] = useState<any>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await TRANS_APIs.getPayments(args); //todo: get api is pending
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        // setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRegions:", error);
    }
  };

  const manageCreditNote = () => {
    const amount = (
      document.getElementById("amount") as HTMLInputElement
    ).value.trim();
    const ststus = document.querySelector(
      'input[name="confirmStatus"]:checked'
    ) as HTMLInputElement;
    const confirmStatus = ststus ? ststus.value : "";

    // const errors = [];
    // if (refNumber === "") {
    //   errors.push({
    //     id: "refNumber",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.REFERENCE_NO +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (amount === "") {
    //   errors.push({
    //     id: "amount",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.AMOUNT +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (remarks === "") {
    //   errors.push({
    //     id: "remarks",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.REMARK +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }

    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,
      confirmStatus,
      amount: confirmStatus === "myBalaceIsDiffrent" ? amount : 100,
      fileId: creditFiles.length > 0 ? creditFiles[0].id : -1,
    };
    setIsSubmit(true);
    return; //todo: api is pending

    TRANS_APIs.manageCreditNote(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setCreditFiles(null);
      uploadFile(file, base64).then((res) => {
        setCreditFiles([res]);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "training",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
      }
    } catch (error) {}
    return fileInfo;
  };

  console.log("Page: Balance Confirmation:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.ACCOUNT}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.BALANCE_CONFIRMATION}</li>
        </ul>
        <h4>{TITLES.BALANCE_CONFIRMATION}</h4>
        <p>{SUB_TITLES.BALANCE_CONFIRMATION}</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "1rem",
          alignItems: "center",
        }}
      >
        Your Balance As Per Our Record is Rs
        <div className="width10" style={{ marginBottom: ".5rem" }}>
          <TxtRow id="amt" disabled={true} defaultValue={1000} />
        </div>
      </div>

      <div className="formGroup width30">
        {/* <label>
          {LABELS.PAYMENT_MODE}
          {<span>{" *"}</span>}
        </label> */}
        <RadioBtn
          list={[
            {
              id: "iAccept",
              label: LABELS.I_ACCEPT,
              value: LABELS.I_ACCEPT,
              checked: selectedRow.id
                ? selectedRow.confirmStatus === "iAccept"
                : true,
              disabled: false,
            },
            {
              id: "myBalaceIsDiffrent",
              label: LABELS.MY_BALANCE_IS_DIFFRENT,
              value: LABELS.MY_BALANCE_IS_DIFFRENT,
              checked: selectedRow.id
                ? selectedRow.confirmStatus === "myBalaceIsDiffrent"
                : false,
              disabled: false,
            },
          ]}
          row={true}
          name={"confirmStatus"}
          disabled={isSubmit}
          onChange={(e) => {
            setconfirmStatus(e);
          }}
        />
      </div>

      {confirmStatus === "myBalaceIsDiffrent" && (
        <>
          <div className="formGroup width25 ">
            <TxtRow
              id={"amount"}
              type={"number"}
              label={LABELS.AMOUNT}
              // required={true}
              defaultValue={selectedRow.amount}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup width25">
            <label>
              {"Balance Attachment"}
              <small>
                {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
              </small>
            </label>
            <TxtBox
              type={"file"}
              id="uploadFile"
              //defaultValue={selectedRow.id}
              //className="uploadFile"
              accept="image/*,.pdf,.mp4"
              onChange={onUploadFile}
            />
            <div>
              {!creditFiles ? (
                <div className="thumbnailBox width20">
                  <SkeletonBox height={300} />
                </div>
              ) : (
                creditFiles.map((u, i) => {
                  return (
                    u.path && (
                      <div className="thumbnailBox width30">
                        <IconButton
                          className="thumbnailBoxIcon"
                          onClick={() => {
                            const list = creditFiles.filter((a, j) => j !== i);
                            setCreditFiles(list);
                          }}
                        >
                          <IconClose />
                        </IconButton>
                        <img
                          onClick={() =>
                            window.open(
                              API_CONFIG.STATIC_URL + u.path,
                              "_blank"
                            )
                          }
                          src={
                            u.mimeType === "application/pdf"
                              ? thumbnailImg
                              : API_CONFIG.STATIC_URL + u.path
                          }
                          className="responsive cursor"
                        />
                        {/* <img
                        onClick={() =>
                          window.open(API_CONFIG.STATIC_URL + u.path, "_blank")
                        }
                        src={
                          u.mimeType === "video/mp4"
                            ? video
                            : API_CONFIG.STATIC_URL + u.path
                        }
                        // className="responsive cursor"
                      /> */}
                      </div>
                    )
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
      {/* {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )} */}

      <div className="formGroup width30">
        <div style={{ alignSelf: "flex-end" }}>
          {/* <Btn
            text={LABELS.CANCEL}
            loading={isSubmit}
            bgColor={COLORS.RELOAD_EXPORT}
            color={COLORS.RELOAD_EXPORT_TEXT}
            onClick={() => {
              setManageDialog(false);
              setMandatoryResults([]);
            }}
          /> */}
          <Btn
            text={LABELS.SAVE}
            loading={isSubmit}
            onClick={manageCreditNote}
            bgColor={COLORS.SAVE_GREEN}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(BalanceConfirmation);
